// DS: MO5.1
import React from 'react';
import c from 'classnames';
import PlainButtonOrLink, { Props as BaseButtonProps } from '../PlainButtonOrLink';
import s from './ExclusiveButton.scss';

interface Props extends BaseButtonProps {
  className?: string;
  priority: 'primary' | 'secondary';
  variant?: 'main' | 'compact' | 'table';
  children?: React.ReactNode;
}

const ExclusiveButton: React.FC<Props> = ({
  className,
  priority,
  children,
  disabled,
  variant = 'main',
  ...props
}) => {
  return (
    <PlainButtonOrLink
      className={c(
        className,
        s['root'],
        s[`priority-${priority}`],
        s[`variant-${variant}`],
        disabled && s['disabled']
      )}
      disabled={disabled}
      {...props}
    >
      {children}
    </PlainButtonOrLink>
  );
};
ExclusiveButton.displayName = 'ExclusiveButton';

export default ExclusiveButton;
